import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './styles.css';
export function Card({ kicker, title, children, id, className, style, onClick }) {
    const classes = ['ui-card'];
    if (className)
        classes.push(className);
    return (_jsxs("article", { className: classes.join(' '), id: id, style: style, onClick: onClick, children: [kicker && _jsx("div", { className: "ui-kicker", children: kicker }), title && _jsx("h3", { children: title }), children] }));
}
